module.exports = __webpack_public_path__ + "static/media/drughelp.329e7b79.png";